import { FC, useRef, useState } from 'react'
import { ReactComponent as PlusIcon } from 'src/assets/svg/tinyPlusIcon.svg'
import { ReactComponent as BrushIcon } from 'src/pages/AIListening/Main/CampaignCard/svgs/brush.svg'
import { ReactComponent as TrashIcon } from 'src/pages/AIListening/Main/CampaignCard/svgs/trash.svg'
import useOutsideClick from 'src/hooks/useOutsideClick'
import styles from './facilityActions.module.scss'

interface FacilityActionsProps {
  onAddLocation: () => void
  onDelete: () => void
  onRename: () => void
}

export const FacilityActions: FC<FacilityActionsProps> = ({
  onAddLocation,
  onDelete,
  onRename,
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useOutsideClick({ onOutsideClick: () => setMenuOpen(false), ref })

  const runAction = (action: () => void) => {
    setMenuOpen(false)
    action()
  }

  return (
    <div className={styles.menuWrapper} ref={ref}>
      <button
        className={styles.menuBtn}
        onClick={() => setMenuOpen((prev) => !prev)}
        type="button"
      >
        <span className={styles.menuDot} />
        <span className={styles.menuDot} />
        <span className={styles.menuDot} />
      </button>
      {menuOpen && (
        <div className={styles.menuDropdown}>
          <button
            className={styles.menuItem}
            onClick={() => runAction(onAddLocation)}
            type="button"
          >
            <PlusIcon className={styles.menuItemIcon} />
            Add location
          </button>
          <button
            className={styles.menuItem}
            onClick={() => runAction(onRename)}
            type="button"
          >
            <BrushIcon className={styles.menuItemIcon} />
            Edit facility
          </button>
          <button
            className={`${styles.menuItem} ${styles.menuItemDelete}`}
            onClick={() => runAction(onDelete)}
            type="button"
          >
            <TrashIcon className={styles.menuItemIcon} />
            Delete facility
          </button>
        </div>
      )}
    </div>
  )
}
